import withSignInAs from './withSignInAs';
import withRedirectSignInAs from './withRedirectSignInAs';

const extensions = {
  sign_in_as: withSignInAs,
  redirect_sign_in_as: withRedirectSignInAs,
};

export default extensions;
